import html2canvas from 'html2canvas';
import canvas2image from './canvas2image';

//html结构转换为image
function  html2image(opts) {
    var option = {
        htmlSelector: 'body',//要转换的html
        dom: null,
        callback:null,//转换完成后回调
        pixelRadio: null,
        width: null
    };
    option = Object.assign({},option, opts);
    var pixelRadio = (option.pixelRadio || parseInt(window.devicePixelRatio) || 2) + 1;//多倍屏canvas会模糊，要乘以scale

    //html转为image
    html2canvas(option.dom || document.querySelector(option.htmlSelector), {
        scale: pixelRadio,
        useCORS: true, //开启跨域配置，否则图片为空白
        ...option
    }).then(canvas => {
        const context = canvas.getContext("2d");
        //消除锯齿
        context.mozImageSmoothingEnabled = false;
        context.webkitImageSmoothingEnabled = false;
        context.msImageSmoothingEnabled = false;
        context.imageSmoothingEnabled = false;
        option.callback&&option.callback(canvas2image.convertToJPEG(canvas, option.width));
    }).catch(err => {
        console.log(err);
        option.callback&&option.callback(null);
    });
};

export default html2image;
